import axios from 'axios'
import qs from 'qs'
import * as apiConstants from '../constants/api-constants'
import { siteUrl } from '../utils/siteUrl'

export const axiosInstance = axios.create()
const ERROR_MESSAGES = {
	DEM360:
		'Algunos de los datos ingresados son inválidos.\nPor favor, verifica los campos e inténtalo nuevamente',
}

class ErrorEventEmitter extends EventTarget {
	emitError(errorCode, customMessage) {
		const message =
			ERROR_MESSAGES[errorCode] ||
			customMessage ||
			'Ha ocurrido un error inesperado'
		this.dispatchEvent(
			new CustomEvent('apiError', {
				detail: { message },
			})
		)
	}
}

export const errorEmitter = new ErrorEventEmitter()

const holderVariables = {}
async function getIp() {
	if (holderVariables.ip) {
		return holderVariables.ip
	}
	if (sessionStorage.getItem("ipAddress")) {
		holderVariables.ip = sessionStorage.getItem("ipAddress")
		return holderVariables.ip
	}
	holderVariables.ip = new Promise((resolve) => {
		axios
			.get(apiConstants.GET_IP_ADDRESS, { timeout: 5000 })
			.then(response => {
				sessionStorage.setItem("ipAddress", response.data.ip)
				resolve(response.data.ip)
			})
			.catch(() => {
				resolve('127.0.0.1')
			})
	})
	return holderVariables.ip
}

axiosInstance.interceptors.request.use(
	async config => {
		const tokenResponse = sessionStorage.getItem("ipAddress") ? sessionStorage.getItem("ipAddress") : await getIp();
		config.headers['Ip-Address'] = tokenResponse;
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

axiosInstance.interceptors.response.use(
	response => {
		if (response?.data?.errorCode) {
			const { errorCode, userMessage } = response.data
			if (ERROR_MESSAGES[errorCode]) {
				errorEmitter.emitError(errorCode, userMessage)
				return Promise.reject({ 
					response, 
					handledGlobally: true,
					errorCode 
				})
			}
		}
		return response
	},
	error => {
		const originalRequest = error.config
		const { response } = error
		const { status } = response

		window.dataLayer = window.dataLayer || []
		window.dataLayer.push({
			event: 'pageError',
			eventTrigger: 'pageError',
			eventCategory: 'Page Error',
			eventAction: `Error ${status}`, //this have to be dynamically pushed.
			eventLabel: originalRequest.siteUrl, //this have to be dynamically pushed.
			eventValue: undefined,
		})

		if (response?.data?.errorCode) {
			const { errorCode, userMessage } = response.data
			if (ERROR_MESSAGES[errorCode]) {
				errorEmitter.emitError(errorCode, userMessage)
				return Promise.reject({ 
					response, 
					handledGlobally: true,
					errorCode 
				})
			}
		}

		if (status === 401) {
			return refreshAccessToken(originalRequest)
		} else {
			return Promise.reject(error)
		}
	}
)

const refreshAccessToken = _originalRequest => {
	_originalRequest._retry = true

	const payload = qs.stringify({
		grant_type: 'refresh_token',
		client_id: apiConstants.CLIENT_ID,
		refresh_token: JSON.parse(localStorage.getItem('TOKEN_INFO')).refreshToken,
	})

	return axiosInstance
		.post(apiConstants.REFRESH_TOKEN, payload, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
			},
		})
		.then(response => {
			if (response.status === 200) {
				const _currentTokenData = JSON.parse(localStorage.getItem('TOKEN_INFO'))
				_currentTokenData.accessToken = response.data.access_token
				_currentTokenData.idToken = response.data.id_token

				localStorage.setItem('TOKEN_INFO', JSON.stringify(_currentTokenData))

				_originalRequest.headers.Authorization = response.data.id_token

				return axios(_originalRequest)
			}
			localStorage.removeItem('USER_INFO')
			localStorage.removeItem('TOKEN_INFO')
			window.location.href = `${siteUrl}/`
		})
		.catch(err => {
			console.log(err)
			localStorage.removeItem('USER_INFO')
			localStorage.removeItem('TOKEN_INFO')
			window.location.href = `${siteUrl}/`
		})
}
